import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoyaltyContext } from '@pegasus/plus';
import { useConfig } from '@browsing/config';
import { CatalogType, getQueryParam } from '@browsing/utils';
import { fetchDataLayer } from '../../api/tracking';
import { getElementFromTrafficSource, getGA4Context, toPageTypeLvl1, getSignalsFromQueryParams, } from '../../helpers';
import { tracker } from '../track';
export const useTrackPageView = ({ page, pageTypeLvl2, earlyAccessPhase, earlyAccessState, isCrossCampaign, isLoaded, isTopPicks, isSacCarousel, campaignId, queryId, }) => {
    const config = useConfig();
    const tracked = useRef(false);
    const loyalty = useLoyaltyContext();
    const location = useLocation();
    useEffect(() => {
        /**
         * We need to reset `tracked` ref whenever `configSku` changes
         * in order to track every article view on PDP after client-side navigation.
         */
        if (config.isEnabled('ga4') && isLoaded) {
            tracked.current = false;
        }
    }, [config, isLoaded]);
    useEffect(() => {
        var _a, _b;
        if (!isLoaded || tracked.current) {
            return;
        }
        if (!config.isEnabled('ga4')) {
            return;
        }
        tracked.current = true;
        const trafficSource = getQueryParam('trafficSource');
        let phase = (earlyAccessPhase === null || earlyAccessPhase === void 0 ? void 0 : earlyAccessPhase.toLowerCase()) || null;
        if (phase === 'invalid') {
            phase = null;
        }
        else if (phase === 'build_up') {
            phase = 'pre_early_access';
        }
        if (earlyAccessState === 'ACTIVE') {
            phase = 'early_access';
        }
        else if (earlyAccessState === 'EXPIRED') {
            phase = 'general_access';
        }
        const loyaltyStatus = (((_a = loyalty.summary) === null || _a === void 0 ? void 0 : _a.status) || '').toLowerCase();
        const loyaltyTier = (((_b = loyalty.summary) === null || _b === void 0 ? void 0 : _b.tier) || '').toLowerCase();
        const querySignals = getSignalsFromQueryParams(location.search);
        const { tarGrp, brands, categories } = querySignals;
        fetchDataLayer().then(({ dataLayer, lead }) => {
            tracker.track('GA4-page_view', Object.assign(Object.assign({}, dataLayer), { event_name: 'page_view', pagetype_lvl_1: toPageTypeLvl1(page), pagetype_lvl_2: pageTypeLvl2 !== null && pageTypeLvl2 !== void 0 ? pageTypeLvl2 : null, pagetype_lvl_3: null, phrase_hash: queryId !== null && queryId !== void 0 ? queryId : null, page_view: {
                    context: getGA4Context({
                        isCrossCampaign,
                        isTopPickArticle: isTopPicks,
                        isSacCarousel,
                        catalogType: CatalogType.Campaign,
                    }),
                    element: getElementFromTrafficSource(trafficSource),
                }, browser_size: `${window.innerWidth}x${window.innerHeight}`, screen_color: `${window.screen.colorDepth}-bit`, screen_resolution: `${window.screen.width}x${window.screen.height}`, early_access_phase: phase, custom_promotion_id: campaignId !== null && campaignId !== void 0 ? campaignId : null, loyalty_status: loyaltyStatus, loyalty_tier: loyaltyTier, target_group: (tarGrp === null || tarGrp === void 0 ? void 0 : tarGrp.toString()) || null, brand_intent: (brands === null || brands === void 0 ? void 0 : brands.toString().split(',').join(';')) || null, category_intent: (categories === null || categories === void 0 ? void 0 : categories.toString().split(',').join(';')) || null }));
            if (lead) {
                tracker.track('GA4-lead', {
                    event_name: 'lead',
                    lead: {
                        method: dataLayer.method,
                    },
                });
            }
        });
    }, [
        config,
        earlyAccessPhase,
        earlyAccessState,
        isCrossCampaign,
        isLoaded,
        isTopPicks,
        page,
        pageTypeLvl2,
        loyalty,
        queryId,
    ]);
};
